import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BrowserQRCodeReader } from "@zxing/library";
import axios from "axios";

import Footer from "../ComponentPrimer/Footer";

const SelfCheckInPembekalan = () => {
  const [scanResult, setScanResult] = useState("Invalid");
  const [name, setName] = useState("Invalid");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const [isScanning, setIsScanning] = useState(true);
  const [countdown, setCountdown] = useState(5); // ⬅️ countdown state
  const videoRef = useRef(null);

  useEffect(() => {
    const codeReader = new BrowserQRCodeReader();

    const startScanning = async () => {
      try {
        if (isScanning) {
          await codeReader.decodeFromVideoDevice(null, videoRef.current, (result, error) => {
            if (result) {
              setScanResult(result.getText());
              checkAndUpdateQRCode(result.getText());
              setIsScanning(false); // stop scanning setelah hasil
            }
            if (error) {
              console.error("Error:", error);
              setScanResult("Invalid");
              setName("Invalid");
            }
          });
        }
      } catch (err) {
        console.error("Failed to initialize scanner:", err);
        setScanResult("Invalid");
        setName("Invalid");
      }
    };

    startScanning();

    return () => {
      codeReader.reset();
    };
  }, [isScanning]);

  useEffect(() => {
    let closeTimeout;
    let interval;

    if (modalOpen) {
      setCountdown(5); // ⬅️ reset countdown ke 5
      interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      closeTimeout = setTimeout(() => {
        setModalOpen(false);
        setIsScanning(true);
      }, 5000);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(closeTimeout);
    };
  }, [modalOpen]);

  const checkAndUpdateQRCode = (qrData) => {
    if (qrData === "Invalid") return;

    axios
      .get(`https://app.rlagency.id/api_pembekalan_wisuda/check-qrcode.php?qrcode=${qrData}`)
      .then((response) => {
        if (response.data.exists) {
          setName(response.data.name);
          updateLog(response.data.nim);
        } else {
          setName("Invalid");
          setScanResult("Invalid");
          showFailureModal();
        }
      })
      .catch((error) => {
        console.error("Error checking QR Code:", error);
        setScanResult("Invalid");
        setName("Invalid");
        showFailureModal();
      });
  };

  const updateLog = (nim) => {
    const currentTime = new Date();
    currentTime.setHours(currentTime.getHours() + 7); // Waktu Jakarta
    const formattedTime = currentTime.toISOString().slice(0, 19).replace('T', ' ');

    axios
      .post("https://app.rlagency.id/api_pembekalan_wisuda/update-log.php", {
        nim: nim,
        log: formattedTime,
      })
      .then((response) => {
        if (response.data.success) {
          setModalMessage("Check-in Berhasil 🎉");
          setModalType("success");
        } else {
          setModalMessage("Gagal Check-in 😢");
          setModalType("failure");
        }
        setModalOpen(true);
      })
      .catch((error) => {
        console.error("Error updating log:", error);
        setModalMessage("Gagal Check-in 😢");
        setModalType("failure");
        setModalOpen(true);
      });
  };

  const showFailureModal = () => {
    setModalMessage("QR Tidak Terdaftar");
    setModalType("failure");
    setModalOpen(true);
  };

  const toggleModal = () => {
    setModalOpen(false);
    setIsScanning(true);
  };

  return (
    <div className="container" style={{ minHeight:'94vh'}}>
      <div style={{ maxWidth: "700px", margin: "50px auto" }}>
        <h1 style={{ fontSize: "24px", textTransform: "uppercase", fontWeight: "600" }}>
          Self Check-In Pembekalan Wisuda
        </h1>

        <div>
          <video ref={videoRef} width="100%" height="auto" style={{ border: "1px solid black" }} />
        </div>

        <p><strong>Nama Lengkap :</strong> {name}</p>

        <Modal isOpen={modalOpen} toggle={toggleModal} size="sm" centered>
          <ModalHeader toggle={toggleModal}>{modalMessage}</ModalHeader>
          <ModalBody>
            <div style={{ textAlign: "center" }}>
              <p><strong>QR Code:</strong><br />{scanResult}</p>
              <p><strong>Nama:</strong><br />{name}</p>
              <p style={{ marginTop: "10px", color: "gray" }}>Menutup otomatis dalam {countdown} detik...</p>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={toggleModal}>
              Tutup ({countdown > 0 ? countdown : 1})
            </button>
          </ModalFooter>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default SelfCheckInPembekalan;